import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createSlots as _createSlots, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_2 = { class: "row items-start q-gutter-sm" }
const _hoisted_3 = {
  key: 0,
  class: "q-pa-sm",
  style: {"border":"1px solid #e0e0e0","border-radius":"6px"}
}
const _hoisted_4 = { class: "text-body2 text-grey-8 q-mb-sm" }
const _hoisted_5 = { class: "row q-gutter-sm" }
const _hoisted_6 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-grey-6 text-center q-mt-xs"
}
const _hoisted_8 = {
  key: 0,
  class: "text-caption text-grey-7 q-mt-xs"
}
const _hoisted_9 = {
  class: "text-grey-8",
  style: {"font-size":"11.5px"}
}
const _hoisted_10 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_11 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_12 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_13 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_14 = { class: "q-mt-sm text-caption text-grey-7" }
const _hoisted_15 = { class: "cursor-pointer text-primary" }
const _hoisted_16 = { class: "cursor-pointer text-primary" }
const _hoisted_17 = { class: "cursor-pointer text-primary" }
const _hoisted_18 = { class: "q-mt-xs" }
const _hoisted_19 = {
  key: 1,
  class: "q-mt-xs"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 2,
  class: "text-caption text-positive row items-center no-wrap"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "q-mt-md" }
const _hoisted_26 = {
  ref: "createMiniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_27 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_28 = { class: "row items-start q-gutter-sm" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "row items-center q-gutter-sm" }
const _hoisted_31 = { class: "text-body2" }
const _hoisted_32 = {
  key: 1,
  class: "q-pa-sm",
  style: {"border":"1px solid #e0e0e0","border-radius":"6px"}
}
const _hoisted_33 = { class: "text-body2 text-grey-8 q-mb-sm" }
const _hoisted_34 = { class: "row q-gutter-sm" }
const _hoisted_35 = {
  key: 2,
  class: "text-caption"
}
const _hoisted_36 = {
  key: 0,
  class: "text-caption text-grey-6 text-center q-mt-xs"
}
const _hoisted_37 = {
  key: 0,
  class: "text-caption text-grey-7 q-mt-xs"
}
const _hoisted_38 = {
  class: "text-grey-8",
  style: {"font-size":"11.5px"}
}
const _hoisted_39 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_40 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_41 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_42 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_43 = { class: "q-mt-sm text-caption text-grey-7" }
const _hoisted_44 = { class: "cursor-pointer text-primary" }
const _hoisted_45 = { class: "cursor-pointer text-primary" }
const _hoisted_46 = { class: "cursor-pointer text-primary" }
const _hoisted_47 = { class: "q-mt-xs" }
const _hoisted_48 = {
  key: 1,
  class: "q-mt-xs"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 2,
  class: "text-caption text-positive row items-center no-wrap"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "row q-gutter-sm" }
const _hoisted_55 = { class: "q-mt-md" }
const _hoisted_56 = {
  ref: "miniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_57 = { style: {"white-space":"pre-wrap","word-break":"break-all","font-size":"13px"} }
const _hoisted_58 = { class: "text-caption text-grey-7 q-mb-sm" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_61 = {
  key: 1,
  class: "text-caption text-positive q-mt-sm row items-center no-wrap"
}
const _hoisted_62 = {
  key: 2,
  class: "text-caption text-grey-7 q-mt-xs"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "text-body2 q-mb-sm" }
const _hoisted_65 = { class: "text-caption text-grey-7 q-mb-xs" }
const _hoisted_66 = { class: "q-ml-sm" }
const _hoisted_67 = { class: "row q-gutter-sm" }
const _hoisted_68 = { class: "col" }
const _hoisted_69 = { class: "col" }
const _hoisted_70 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_71 = {
  key: 1,
  class: "text-caption text-positive q-mt-sm row items-center no-wrap"
}
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { class: "row items-center q-gutter-sm q-mb-xs" }
const _hoisted_75 = { class: "text-caption text-grey-7 q-mb-xs" }
const _hoisted_76 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_77 = {
  key: 1,
  class: "text-caption text-grey-7 q-mt-sm row items-center no-wrap"
}
const _hoisted_78 = {
  key: 2,
  class: "text-caption text-positive q-mt-sm row items-center no-wrap"
}
const _hoisted_79 = { key: 4 }
const _hoisted_80 = { class: "text-body2 q-mb-sm" }
const _hoisted_81 = {
  ref: "builderMiniMap",
  style: {"height":"280px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"540px","max-width":"95vw"},
          class: "manage-ps-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createTextVNode("Pipeline Manager", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
              dense: "",
              class: "text-grey",
              "active-color": "blue-brand",
              "indicator-color": "blue-brand",
              align: "left",
              "update-csv-file": "",
              "narrow-indicator": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab, {
                  name: "create",
                  label: "Create New"
                }),
                _createVNode(_component_q_tab, {
                  name: "update",
                  label: "Update Existing"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_tab_panels, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.tab) = $event)),
              animated: "",
              "keep-alive": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab_panel, { name: "create" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.createName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createName) = $event)),
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name e.g., Oklahoma City to Tulsa",
                        error: _ctx.createNameError !== '',
                        "error-message": _ctx.createNameError
                      }, null, 8, ["modelValue", "error", "error-message"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.createDiameter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.createDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          error: _ctx.createDiameterError !== '',
                          "error-message": _ctx.createDiameterError,
                          rules: [_ctx.createDiameterRule],
                          "reactive-rules": "",
                          class: "col"
                        }, null, 8, ["modelValue", "label", "error", "error-message", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.createDiameterUnit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.createCsvMode === null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_q_icon, {
                                name: "help_outline",
                                size: "18px",
                                class: "q-mr-xs"
                              }),
                              _cache[48] || (_cache[48] = _createTextVNode(" Do you have a properly formatted CSV file describing your pipeline? ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_q_btn, {
                                outline: "",
                                color: "blue-brand",
                                label: "Yes – upload CSV",
                                icon: "upload_file",
                                size: "sm",
                                "no-caps": "",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createCsvMode = 'csv'))
                              }),
                              _createVNode(_component_q_btn, {
                                outline: "",
                                color: "blue-brand",
                                label: "No – build step by step",
                                icon: "construction",
                                size: "sm",
                                "no-caps": "",
                                onClick: _ctx.onOpenBuilder
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.createCsvMode !== null && !_ctx.createCsvFile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-grey-7",
                              style: {"text-decoration":"underline"},
                              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onResetCsvMode && _ctx.onResetCsvMode(...args)), ["prevent"]))
                            }, " ← Change how you provide marker data ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.createCsvMode === 'csv')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["csv-drop-zone", { 'csv-drop-zone--active': _ctx.createDragOver }]),
                              onDragover: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.createDragOver = true), ["prevent"])),
                              onDragenter: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.createDragOver = true), ["prevent"])),
                              onDragleave: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.createDragOver = false), ["prevent"])),
                              onDrop: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onDropCsv($event, 'create')), ["prevent"]))
                            }, [
                              _createVNode(_component_q_file, {
                                modelValue: _ctx.createCsvFile,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createCsvFile) = $event)),
                                dense: "",
                                outlined: "",
                                color: "blue-brand",
                                label: "Survey Markers and Tracking Locations (CSV) File Upload",
                                accept: ".csv",
                                clearable: "",
                                error: _ctx.createCsvFileError !== '',
                                "error-message": _ctx.createCsvFileError
                              }, _createSlots({
                                prepend: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "attach_file" })
                                ]),
                                _: 2
                              }, [
                                (_ctx.createCsvFile && _ctx.createCsvValidation)
                                  ? {
                                      name: "append",
                                      fn: _withCtx(() => [
                                        (_ctx.createCsvValidation.errors.length > 0)
                                          ? (_openBlock(), _createBlock(_component_q_badge, {
                                              key: 0,
                                              color: "negative",
                                              label: 
                        _ctx.createCsvValidation.errors.length +
                        ' error' +
                        (_ctx.createCsvValidation.errors.length > 1 ? 's' : '')
                      ,
                                              class: "q-mr-xs"
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.createCsvValidation.warnings.length > 0)
                                          ? (_openBlock(), _createBlock(_component_q_badge, {
                                              key: 1,
                                              color: "amber-8",
                                              label: 
                        _ctx.createCsvValidation.warnings.length +
                        ' warning' +
                        (_ctx.createCsvValidation.warnings.length > 1 ? 's' : '')
                      
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032, ["modelValue", "error", "error-message"]),
                              (!_ctx.createCsvFile)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " or drag & drop a CSV file here "))
                                : _createCommentVNode("", true)
                            ], 34),
                            (!_ctx.createCsvFile)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_q_icon, {
                                      name: "info",
                                      size: "14px",
                                      class: "q-mr-xs"
                                    }),
                                    _cache[49] || (_cache[49] = _createTextVNode(" Valid header formats (click ", -1)),
                                    _createVNode(_component_q_icon, {
                                      name: "content_copy",
                                      size: "12px"
                                    }),
                                    _cache[50] || (_cache[50] = _createTextVNode(" to copy): ", -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[51] || (_cache[51] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _cache[52] || (_cache[52] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Meters),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Meters),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[53] || (_cache[53] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Feet),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Feet),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_13, [
                                    _cache[54] || (_cache[54] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Miles),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Miles),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _cache[61] || (_cache[61] = _createTextVNode(" Hover over each to see descriptive help: ", -1)),
                                    _createElementVNode("span", _hoisted_15, [
                                      _cache[56] || (_cache[56] = _createTextVNode(" State", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "220px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                          _createTextVNode(" Valid values: TRACK, SKIP ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _cache[62] || (_cache[62] = _createTextVNode(", ", -1)),
                                    _createElementVNode("span", _hoisted_16, [
                                      _cache[58] || (_cache[58] = _createTextVNode(" Description", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "280px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                          _createTextVNode(" Valid values: AGM, ATTACHMENT, BEND, LAUNCH, MAGNET, OTHER, PIPE, RECEIVE, TAP, TEE, VALVE, WELD ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _cache[63] || (_cache[63] = _createTextVNode(", ", -1)),
                                    _createElementVNode("span", _hoisted_17, [
                                      _cache[60] || (_cache[60] = _createTextVNode(" Pipeline Distance ", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "300px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                          _createTextVNode(" Use column header \"Pipeline Distance (Meters)\", \"Pipeline Distance (Feet)\", or \"Pipeline Distance (Miles)\". Start at 0 for the Launch row, and increase for each subsequent row since it represents the cumulative distance along the pipeline. ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "text-primary text-caption",
                                      style: {"text-decoration":"underline"},
                                      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownloadExampleCsv && _ctx.onDownloadExampleCsv(...args)), ["prevent"]))
                                    }, "Download example CSV")
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.createCsvFile && _ctx.createCsvValidation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (_ctx.createCsvValidation.errors.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showAllCreateErrors
                      ? _ctx.createCsvValidation.errors
                      : _ctx.createCsvValidation.errors.slice(0, 3), (err, idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'ce-' + idx,
                                            class: "text-caption text-negative row items-start no-wrap q-mb-xs",
                                            style: _normalizeStyle(_ctx.hasRowRef(err) ? { cursor: 'pointer' } : {}),
                                            onClick: ($event: any) => (_ctx.scrollToErrorRow('createPreviewTable', err))
                                          }, [
                                            _createVNode(_component_q_icon, {
                                              name: "error",
                                              size: "16px",
                                              class: "q-mr-xs",
                                              color: "negative",
                                              style: {"flex-shrink":"0","margin-top":"1px"}
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(err), 1)
                                          ], 12, _hoisted_21))
                                        }), 128)),
                                        (
                      _ctx.createCsvValidation.errors.length > 3 &&
                      !_ctx.showAllCreateErrors
                    )
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              href: "#",
                                              class: "text-caption text-primary",
                                              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.showAllCreateErrors = true), ["prevent"]))
                                            }, " Show " + _toDisplayString(_ctx.createCsvValidation.errors.length - 3) + " more error(s) ", 1))
                                          : _createCommentVNode("", true),
                                        (
                      _ctx.createCsvValidation.errors.length > 3 &&
                      _ctx.showAllCreateErrors
                    )
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: "#",
                                              class: "text-caption text-primary",
                                              onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.showAllCreateErrors = false), ["prevent"]))
                                            }, " Show fewer errors "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.createCsvValidation.warnings.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createCsvValidation.warnings, (warn, idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'cw-' + idx,
                                            class: "text-caption text-amber-9 row items-start no-wrap q-mb-xs"
                                          }, [
                                            _createVNode(_component_q_icon, {
                                              name: "warning",
                                              size: "16px",
                                              class: "q-mr-xs",
                                              color: "amber-8",
                                              style: {"flex-shrink":"0","margin-top":"1px"}
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(warn), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.createCsvValidation.valid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createVNode(_component_q_icon, {
                                          name: "check_circle",
                                          size: "16px",
                                          class: "q-mr-xs",
                                          color: "positive"
                                        }),
                                        _createElementVNode("span", null, [
                                          _createTextVNode(_toDisplayString(_ctx.createCsvValidation.parsedRows.length) + " data rows, " + _toDisplayString(_ctx.createCsvValidation.markerCount) + " markers parsed — " + _toDisplayString(_ctx.createCsvValidation.firstMarker) + " → " + _toDisplayString(_ctx.createCsvValidation.lastMarker), 1),
                                          (_ctx.createCsvValidation.skipCount > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " · " + _toDisplayString(_ctx.createCsvValidation.skipCount) + " SKIP", 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (
                  _ctx.createCsvFile &&
                  _ctx.createCsvValidation &&
                  _ctx.createCsvValidation.parsedRows.length > 0
                )
                              ? (_openBlock(), _createBlock(_component_q_table, {
                                  key: 2,
                                  ref: "createPreviewTable",
                                  rows: _ctx.createCsvValidation.parsedRows,
                                  columns: _ctx.csvPreviewColumns,
                                  "row-key": "row",
                                  flat: "",
                                  bordered: "",
                                  dense: "",
                                  "hide-bottom": "",
                                  "rows-per-page-options": [0],
                                  class: "q-mt-sm csv-preview-table",
                                  style: { maxHeight: '200px', overflowY: 'auto' }
                                }, {
                                  body: _withCtx((props) => [
                                    _createVNode(_component_q_tr, {
                                      props: props,
                                      "data-row": props.row.row
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                          return (_openBlock(), _createBlock(_component_q_td, {
                                            key: col.name,
                                            props: props,
                                            class: _normalizeClass({
                        'bg-red-1': props.row.errorFields.includes(col.name),
                      })
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(col.value), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["props", "class"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["props", "data-row"])
                                  ]),
                                  _: 1
                                }, 8, ["rows", "columns"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createVNode(_component_q_btn, {
                                class: "btn-brand",
                                label: "Create",
                                loading: _ctx.loading,
                                disable: 
                    !!(
                      _ctx.createCsvFile &&
                      (!_ctx.createCsvValidation || !_ctx.createCsvValidation.valid)
                    )
                  ,
                                onClick: _ctx.onCreateSubmit
                              }, null, 8, ["loading", "disable", "onClick"])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_25, [
                              _cache[64] || (_cache[64] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                              _createElementVNode("div", _hoisted_26, null, 512)
                            ], 512), [
                              [_vShow, _ctx.createCsvFile]
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, { name: "update" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedPipelineSection,
                        "onUpdate:modelValue": [
                          _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedPipelineSection) = $event)),
                          _ctx.onPipelineSectionSelected
                        ],
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name",
                        options: _ctx.pipelineSectionOptions,
                        loading: _ctx.loading,
                        clearable: "",
                        onClear: _ctx.onPipelineSectionCleared
                      }, null, 8, ["modelValue", "options", "loading", "onUpdate:modelValue", "onClear"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.updateDiameter,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.updateDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.updateDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          disable: !_ctx.selectedPipelineSection,
                          rules: [(val) => !!val || 'Diameter is required.'],
                          class: "col"
                        }, null, 8, ["modelValue", "label", "disable", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.updateDiameterUnit,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.updateDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          disable: !_ctx.selectedPipelineSection,
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue", "disable"])
                      ]),
                      (_ctx.selectedPipelineSection && _ctx.currentTrackingFileName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _cache[65] || (_cache[65] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Current Tracking File ", -1)),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.currentTrackingFileName), 1),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "visibility",
                                color: "blue-brand",
                                title: "View file",
                                onClick: _ctx.onViewTrackingFile
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "download",
                                color: "blue-brand",
                                title: "Download file",
                                onClick: _ctx.onDownloadTrackingFile
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPipelineSection && _ctx.updateCsvMode === null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_q_icon, {
                                name: "help_outline",
                                size: "18px",
                                class: "q-mr-xs"
                              }),
                              _cache[66] || (_cache[66] = _createTextVNode(" Do you have a properly formatted CSV file describing your replacement pipeline markers? ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_q_btn, {
                                outline: "",
                                color: "blue-brand",
                                label: "Yes – upload CSV",
                                icon: "upload_file",
                                size: "sm",
                                "no-caps": "",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateCsvMode = 'csv'))
                              }),
                              _createVNode(_component_q_btn, {
                                outline: "",
                                color: "blue-brand",
                                label: "No – build step by step",
                                icon: "construction",
                                size: "sm",
                                "no-caps": "",
                                onClick: _ctx.onOpenUpdateBuilder
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.updateCsvMode !== null && !_ctx.updateCsvFile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-grey-7",
                              style: {"text-decoration":"underline"},
                              onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onResetUpdateCsvMode && _ctx.onResetUpdateCsvMode(...args)), ["prevent"]))
                            }, " ← Change how you provide marker data ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.updateCsvMode === 'csv')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["csv-drop-zone", {
                  'csv-drop-zone--active':
                    _ctx.updateDragOver && _ctx.selectedPipelineSection,
                }]),
                              onDragover: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.updateDragOver = true), ["prevent"])),
                              onDragenter: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.updateDragOver = true), ["prevent"])),
                              onDragleave: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.updateDragOver = false), ["prevent"])),
                              onDrop: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.onDropCsv($event, 'update')), ["prevent"]))
                            }, [
                              _createVNode(_component_q_file, {
                                modelValue: _ctx.updateCsvFile,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.updateCsvFile) = $event)),
                                dense: "",
                                outlined: "",
                                color: "blue-brand",
                                label: "Survey Markers and Tracking Locations (CSV) File Upload",
                                accept: ".csv",
                                clearable: "",
                                disable: !_ctx.selectedPipelineSection
                              }, _createSlots({
                                prepend: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "attach_file" })
                                ]),
                                _: 2
                              }, [
                                (_ctx.updateCsvFile && _ctx.updateCsvValidation)
                                  ? {
                                      name: "append",
                                      fn: _withCtx(() => [
                                        (_ctx.updateCsvValidation.errors.length > 0)
                                          ? (_openBlock(), _createBlock(_component_q_badge, {
                                              key: 0,
                                              color: "negative",
                                              label: 
                        _ctx.updateCsvValidation.errors.length +
                        ' error' +
                        (_ctx.updateCsvValidation.errors.length > 1 ? 's' : '')
                      ,
                                              class: "q-mr-xs"
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.updateCsvValidation.warnings.length > 0)
                                          ? (_openBlock(), _createBlock(_component_q_badge, {
                                              key: 1,
                                              color: "amber-8",
                                              label: 
                        _ctx.updateCsvValidation.warnings.length +
                        ' warning' +
                        (_ctx.updateCsvValidation.warnings.length > 1 ? 's' : '')
                      
                                            }, null, 8, ["label"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032, ["modelValue", "disable"]),
                              (!_ctx.updateCsvFile && _ctx.selectedPipelineSection)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, " or drag & drop a CSV file here "))
                                : _createCommentVNode("", true)
                            ], 34),
                            (!_ctx.updateCsvFile && _ctx.selectedPipelineSection)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createVNode(_component_q_icon, {
                                      name: "info",
                                      size: "14px",
                                      class: "q-mr-xs"
                                    }),
                                    _cache[67] || (_cache[67] = _createTextVNode(" Valid header formats (click ", -1)),
                                    _createVNode(_component_q_icon, {
                                      name: "content_copy",
                                      size: "12px"
                                    }),
                                    _cache[68] || (_cache[68] = _createTextVNode(" to copy): ", -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _cache[69] || (_cache[69] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _cache[70] || (_cache[70] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Meters),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Meters),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _cache[71] || (_cache[71] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Feet),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Feet),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    _cache[72] || (_cache[72] = _createElementVNode("code", {
                                      class: "text-grey-9",
                                      style: {"font-size":"11px","flex":"1"}
                                    }, " AGM Marker Name,Latitude,Longitude,Pipeline Distance (Miles),State,Description ", -1)),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      dense: "",
                                      size: "xs",
                                      icon: "content_copy",
                                      color: "grey-7",
                                      title: "Copy header to clipboard",
                                      class: "q-ml-xs",
                                      onClick: _cache[31] || (_cache[31] = ($event: any) => (
                      _ctx.onCopyHeaderText(
                        'AGM Marker Name,Latitude,Longitude,Pipeline Distance (Miles),State,Description'
                      )
                    ))
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_43, [
                                    _cache[79] || (_cache[79] = _createTextVNode(" Hover over each to see descriptive help: ", -1)),
                                    _createElementVNode("span", _hoisted_44, [
                                      _cache[74] || (_cache[74] = _createTextVNode(" State", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "220px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                          _createTextVNode(" Valid values: TRACK, SKIP ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _cache[80] || (_cache[80] = _createTextVNode(", ", -1)),
                                    _createElementVNode("span", _hoisted_45, [
                                      _cache[76] || (_cache[76] = _createTextVNode(" Description", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "280px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                          _createTextVNode(" Valid values: AGM, ATTACHMENT, BEND, LAUNCH, MAGNET, OTHER, PIPE, RECEIVE, TAP, TEE, VALVE, WELD ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _cache[81] || (_cache[81] = _createTextVNode(", ", -1)),
                                    _createElementVNode("span", _hoisted_46, [
                                      _cache[78] || (_cache[78] = _createTextVNode(" Pipeline Distance ", -1)),
                                      _createVNode(_component_q_tooltip, {
                                        class: "text-body2",
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        "max-width": "300px"
                                      }, {
                                        default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                          _createTextVNode(" Use column header \"Pipeline Distance (Meters)\", \"Pipeline Distance (Feet)\", or \"Pipeline Distance (Miles)\". Start at 0 for the Launch row, and increase for each subsequent row since it represents the cumulative distance along the pipeline. ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "text-primary text-caption",
                                      style: {"text-decoration":"underline"},
                                      onClick: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownloadExampleCsv && _ctx.onDownloadExampleCsv(...args)), ["prevent"]))
                                    }, "Download example CSV")
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.updateCsvFile && _ctx.updateCsvValidation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  (_ctx.updateCsvValidation.errors.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showAllUpdateErrors
                      ? _ctx.updateCsvValidation.errors
                      : _ctx.updateCsvValidation.errors.slice(0, 3), (err, idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'ue-' + idx,
                                            class: "text-caption text-negative row items-start no-wrap q-mb-xs",
                                            style: _normalizeStyle(_ctx.hasRowRef(err) ? { cursor: 'pointer' } : {}),
                                            onClick: ($event: any) => (_ctx.scrollToErrorRow('updatePreviewTable', err))
                                          }, [
                                            _createVNode(_component_q_icon, {
                                              name: "error",
                                              size: "16px",
                                              class: "q-mr-xs",
                                              color: "negative",
                                              style: {"flex-shrink":"0","margin-top":"1px"}
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(err), 1)
                                          ], 12, _hoisted_50))
                                        }), 128)),
                                        (
                      _ctx.updateCsvValidation.errors.length > 3 &&
                      !_ctx.showAllUpdateErrors
                    )
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              href: "#",
                                              class: "text-caption text-primary",
                                              onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.showAllUpdateErrors = true), ["prevent"]))
                                            }, " Show " + _toDisplayString(_ctx.updateCsvValidation.errors.length - 3) + " more error(s) ", 1))
                                          : _createCommentVNode("", true),
                                        (
                      _ctx.updateCsvValidation.errors.length > 3 &&
                      _ctx.showAllUpdateErrors
                    )
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: "#",
                                              class: "text-caption text-primary",
                                              onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.showAllUpdateErrors = false), ["prevent"]))
                                            }, " Show fewer errors "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.updateCsvValidation.warnings.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateCsvValidation.warnings, (warn, idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'uw-' + idx,
                                            class: "text-caption text-amber-9 row items-start no-wrap q-mb-xs"
                                          }, [
                                            _createVNode(_component_q_icon, {
                                              name: "warning",
                                              size: "16px",
                                              class: "q-mr-xs",
                                              color: "amber-8",
                                              style: {"flex-shrink":"0","margin-top":"1px"}
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(warn), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.updateCsvValidation.valid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                        _createVNode(_component_q_icon, {
                                          name: "check_circle",
                                          size: "16px",
                                          class: "q-mr-xs",
                                          color: "positive"
                                        }),
                                        _createElementVNode("span", null, [
                                          _createTextVNode(_toDisplayString(_ctx.updateCsvValidation.parsedRows.length) + " data rows, " + _toDisplayString(_ctx.updateCsvValidation.markerCount) + " markers parsed — " + _toDisplayString(_ctx.updateCsvValidation.firstMarker) + " → " + _toDisplayString(_ctx.updateCsvValidation.lastMarker), 1),
                                          (_ctx.updateCsvValidation.skipCount > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, " · " + _toDisplayString(_ctx.updateCsvValidation.skipCount) + " SKIP", 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (
                  _ctx.updateCsvFile &&
                  _ctx.updateCsvValidation &&
                  _ctx.updateCsvValidation.parsedRows.length > 0
                )
                              ? (_openBlock(), _createBlock(_component_q_table, {
                                  key: 2,
                                  ref: "updatePreviewTable",
                                  rows: _ctx.updateCsvValidation.parsedRows,
                                  columns: _ctx.csvPreviewColumns,
                                  "row-key": "row",
                                  flat: "",
                                  bordered: "",
                                  dense: "",
                                  "hide-bottom": "",
                                  "rows-per-page-options": [0],
                                  class: "q-mt-sm csv-preview-table",
                                  style: { maxHeight: '200px', overflowY: 'auto' }
                                }, {
                                  body: _withCtx((props) => [
                                    _createVNode(_component_q_tr, {
                                      props: props,
                                      "data-row": props.row.row
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                          return (_openBlock(), _createBlock(_component_q_td, {
                                            key: col.name,
                                            props: props,
                                            class: _normalizeClass({
                        'bg-red-1': props.row.errorFields.includes(col.name),
                      })
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(col.value), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["props", "class"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["props", "data-row"])
                                  ]),
                                  _: 1
                                }, 8, ["rows", "columns"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Update",
                          disable: 
                  !_ctx.selectedPipelineSection ||
                  _ctx.updateAction !== null ||
                  _ctx.updateCsvMode === 'builder' ||
                  !!(
                    _ctx.updateCsvFile &&
                    (!_ctx.updateCsvValidation || !_ctx.updateCsvValidation.valid)
                  )
                ,
                          loading: _ctx.updateAction === 'update',
                          onClick: _ctx.onUpdateSubmit
                        }, null, 8, ["disable", "loading", "onClick"]),
                        _createVNode(_component_q_btn, {
                          color: "negative",
                          label: "Delete",
                          disable: !_ctx.selectedPipelineSection || _ctx.updateAction !== null,
                          loading: _ctx.updateAction === 'delete',
                          onClick: _ctx.onDeleteSubmit
                        }, null, 8, ["disable", "loading", "onClick"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_55, [
                        _cache[82] || (_cache[82] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                        _createElementVNode("div", _hoisted_56, null, 512)
                      ], 512), [
                        [_vShow, _ctx.selectedPipelineSection && _ctx.currentTrackingFile]
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.viewTrackingFileDialog,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.viewTrackingFileDialog) = $event)),
          maximized: "",
          onHide: _ctx.onViewTrackingFileDialogHide
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toolbar_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentTrackingFileName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "download",
                      title: "Download",
                      onClick: _ctx.onDownloadTrackingFile
                    }, null, 8, ["onClick"]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "close"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, {
                  class: "q-pa-md",
                  style: {"overflow":"auto","max-height":"calc(100vh - 50px)"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_57, _toDisplayString(_ctx.currentTrackingFile), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onHide"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showBuilderDialog,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.showBuilderDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"500px","max-width":"95vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.builderDialogTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  onClick: _ctx.onBuilderCancel
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, " Step " + _toDisplayString(_ctx.builderStep) + " of 5 ", 1),
                (_ctx.builderStep === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "text-body2 q-mb-sm" }, " Copy the AGM marker name column from your survey spreadsheet in Excel and paste it below. One name per row. ", -1)),
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.builderMarkerNamesRaw,
                        "onUpdate:modelValue": [
                          _cache[38] || (_cache[38] = ($event: any) => ((_ctx.builderMarkerNamesRaw) = $event)),
                          _ctx.validateBuilderMarkerNames
                        ],
                        type: "textarea",
                        outlined: "",
                        dense: "",
                        color: "blue-brand",
                        placeholder: "Launch\nAGM-001\nAGM-002\nReceive",
                        rows: "10"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (_ctx.builderMarkerNameErrors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builderMarkerNameErrors, (err, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'bne-' + idx,
                                class: "text-caption text-negative row items-start no-wrap q-mb-xs"
                              }, [
                                _createVNode(_component_q_icon, {
                                  name: "error",
                                  size: "16px",
                                  class: "q-mr-xs",
                                  color: "negative",
                                  style: {"flex-shrink":"0","margin-top":"1px"}
                                }),
                                _createElementVNode("span", null, _toDisplayString(err), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (
              _ctx.builderMarkerNames.length > 0 &&
              _ctx.builderMarkerNameErrors.length === 0
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createVNode(_component_q_icon, {
                              name: "check_circle",
                              size: "16px",
                              class: "q-mr-xs",
                              color: "positive"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.builderMarkerNames.length) + " marker names entered", 1)
                          ]))
                        : (
              _ctx.builderMarkerNames.length > 0 &&
              _ctx.builderMarkerNameErrors.length > 0
            )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.builderMarkerNames.length) + " name(s) parsed so far ", 1))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.builderStep === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, " Paste latitude and longitude columns separately. Row order must match the " + _toDisplayString(_ctx.builderMarkerNames.length) + " marker names from the previous step. Each marker should be at least 2 m from the next (10+ m recommended). ", 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createTextVNode(" Expected: " + _toDisplayString(_ctx.builderMarkerNames.length) + " coordinate pairs ", 1),
                        _createElementVNode("span", _hoisted_66, " Latitudes: " + _toDisplayString(_ctx.builderLatitudeCount) + " of " + _toDisplayString(_ctx.builderMarkerNames.length) + " · Longitudes: " + _toDisplayString(_ctx.builderLongitudeCount) + " of " + _toDisplayString(_ctx.builderMarkerNames.length), 1)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.builderLatitudesRaw,
                            "onUpdate:modelValue": [
                              _cache[39] || (_cache[39] = ($event: any) => ((_ctx.builderLatitudesRaw) = $event)),
                              _ctx.validateBuilderCoords
                            ],
                            type: "textarea",
                            outlined: "",
                            dense: "",
                            color: "blue-brand",
                            label: "Latitudes",
                            placeholder: "35.4676\n35.4812\n35.4955\n35.5101",
                            rows: "10"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.builderLongitudesRaw,
                            "onUpdate:modelValue": [
                              _cache[40] || (_cache[40] = ($event: any) => ((_ctx.builderLongitudesRaw) = $event)),
                              _ctx.validateBuilderCoords
                            ],
                            type: "textarea",
                            outlined: "",
                            dense: "",
                            color: "blue-brand",
                            label: "Longitudes",
                            placeholder: "-97.5164\n-97.5032\n-97.4898\n-97.4771",
                            rows: "10"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      (_ctx.builderCoordErrors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builderCoordErrors, (err, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'bce-' + idx,
                                class: "text-caption text-negative row items-start no-wrap q-mb-xs"
                              }, [
                                _createVNode(_component_q_icon, {
                                  name: "error",
                                  size: "16px",
                                  class: "q-mr-xs",
                                  color: "negative",
                                  style: {"flex-shrink":"0","margin-top":"1px"}
                                }),
                                _createElementVNode("span", null, _toDisplayString(err), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.builderCoordErrors.length === 0 && _ctx.builderCoordsValid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createVNode(_component_q_icon, {
                              name: "check_circle",
                              size: "16px",
                              class: "q-mr-xs",
                              color: "positive"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.builderMarkerNames.length) + " coordinate pairs entered", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.builderStep === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _cache[84] || (_cache[84] = _createElementVNode("div", { class: "text-body2 q-mb-sm" }, [
                        _createElementVNode("div", null, " AGM markers are tracked by default. Launch (first) and Receive (last) are skipped by default - check any marker you want tracked. ")
                      ], -1)),
                      _createVNode(_component_q_list, {
                        bordered: "",
                        separator: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builderMarkerNames, (markerName, index) => {
                            return (_openBlock(), _createBlock(_component_q_item, {
                              key: markerName,
                              dense: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_checkbox, {
                                      modelValue: _ctx.builderTrackStates[index],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.builderTrackStates[index]) = $event),
                                      label: markerName,
                                      "true-value": "T",
                                      "false-value": "S",
                                      color: "blue-brand"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, { side: "" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                    _ctx.builderTrackStates[index] === 'T'
                      ? 'text-positive'
                      : 'text-grey-7'
                  , "text-caption"])
                                    }, _toDisplayString(_ctx.builderTrackStates[index] === 'T' ? 'Track' : 'Skip'), 3)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.builderStep === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _cache[86] || (_cache[86] = _createElementVNode("div", { class: "text-body2 q-mb-sm" }, " Optionally paste cumulative pipeline distances below, one value per marker row. Values must start at 0 and increase for each subsequent row. ", -1)),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.builderDistanceUnit,
                          "onUpdate:modelValue": [
                            _cache[41] || (_cache[41] = ($event: any) => ((_ctx.builderDistanceUnit) = $event)),
                            _ctx.onBuilderDistanceUnitChange
                          ],
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: "Distance unit",
                          options: [
                { label: 'Feet', value: 'feet' },
                { label: 'Meters', value: 'meters' },
                { label: 'Miles', value: 'miles' },
              ],
                          "emit-value": "",
                          "map-options": "",
                          style: {"width":"160px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_q_btn, {
                          flat: "",
                          dense: "",
                          color: "blue-brand",
                          label: "Skip distance",
                          "no-caps": "",
                          onClick: _ctx.onSkipBuilderDistances
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_75, " Expected: " + _toDisplayString(_ctx.builderMarkerNames.length) + " " + _toDisplayString(_ctx.builderDistanceUnit) + " values · Entered: " + _toDisplayString(_ctx.builderDistanceCount) + " of " + _toDisplayString(_ctx.builderMarkerNames.length), 1),
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.builderDistancesRaw,
                        "onUpdate:modelValue": [
                          _cache[42] || (_cache[42] = ($event: any) => ((_ctx.builderDistancesRaw) = $event)),
                          _ctx.onBuilderDistanceInput
                        ],
                        type: "textarea",
                        outlined: "",
                        dense: "",
                        color: "blue-brand",
                        label: `Cumulative Pipeline Distance (${
              _ctx.builderDistanceUnit === 'feet'
                ? 'Feet'
                : _ctx.builderDistanceUnit === 'miles'
                ? 'Miles'
                : 'Meters'
            })`,
                        placeholder: 
              _ctx.builderDistanceUnit === 'feet'
                ? '0\n250\n575\n910'
                : _ctx.builderDistanceUnit === 'miles'
                ? '0\n0.047\n0.109\n0.172'
                : '0\n76.2\n175.3\n277.4'
            ,
                        rows: "10"
                      }, null, 8, ["modelValue", "label", "placeholder", "onUpdate:modelValue"]),
                      (_ctx.builderDistanceErrors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builderDistanceErrors, (err, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'bde-' + idx,
                                class: "text-caption text-negative row items-start no-wrap q-mb-xs"
                              }, [
                                _createVNode(_component_q_icon, {
                                  name: "error",
                                  size: "16px",
                                  class: "q-mr-xs",
                                  color: "negative",
                                  style: {"flex-shrink":"0","margin-top":"1px"}
                                }),
                                _createElementVNode("span", null, _toDisplayString(err), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_ctx.builderDistanceSkipped)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createVNode(_component_q_icon, {
                                name: "skip_next",
                                size: "16px",
                                class: "q-mr-xs"
                              }),
                              _cache[85] || (_cache[85] = _createElementVNode("span", null, "Pipeline distance will not be included.", -1))
                            ]))
                          : (_ctx.builderDistancesValid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _createVNode(_component_q_icon, {
                                  name: "check_circle",
                                  size: "16px",
                                  class: "q-mr-xs",
                                  color: "positive"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.builderDistanceCount) + " cumulative distances entered", 1)
                              ]))
                            : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.builderStep === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, " Scroll or pinch to zoom - drag to pan - tap a marker to toggle TRACK/SKIP. Click Finish to " + _toDisplayString(_ctx.builderOperation === 'update' ? 'update' : 'create') + " the pipeline section. ", 1),
                      _cache[87] || (_cache[87] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, "Pipeline Preview", -1)),
                      _createElementVNode("div", _hoisted_81, null, 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Cancel",
                  color: "grey-7",
                  "no-caps": "",
                  onClick: _ctx.onBuilderCancel
                }, null, 8, ["onClick"]),
                (_ctx.builderStep > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      flat: "",
                      label: "Back",
                      color: "grey-7",
                      "no-caps": "",
                      onClick: _ctx.onBuilderBack
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  label: _ctx.builderStep < 5 ? 'Next' : 'Finish',
                  "no-caps": "",
                  disable: !_ctx.builderStepValid || _ctx.loading,
                  loading: _ctx.loading,
                  onClick: _ctx.onBuilderNext
                }, null, 8, ["label", "disable", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showDuplicateMarkerDialog,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.showDuplicateMarkerDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"500px","max-width":"95vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "warning",
                  color: "warning",
                  size: "24px",
                  class: "q-mr-sm"
                }),
                _cache[88] || (_cache[88] = _createElementVNode("div", { class: "text-h6" }, "Duplicate Marker Names", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[90] || (_cache[90] = _createElementVNode("div", { class: "text-body2 q-mb-md" }, " Each marker needs a unique name. We suggest numbering duplicates like VALVE -> VALVE_1, VALVE_2: ", -1)),
                _createVNode(_component_q_markup_table, {
                  flat: "",
                  bordered: "",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _cache[89] || (_cache[89] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "text-left" }, "Row"),
                        _createElementVNode("th", { class: "text-left" }, "Original"),
                        _createElementVNode("th", { class: "text-left" }, "Proposed")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicateMarkerNameChanges, (change) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: change.row
                        }, [
                          _createElementVNode("td", null, _toDisplayString(change.row), 1),
                          _createElementVNode("td", null, _toDisplayString(change.originalName), 1),
                          _createElementVNode("td", null, _toDisplayString(change.proposedName), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _cache[91] || (_cache[91] = _createElementVNode("div", { class: "text-body2 q-mt-md" }, " Apply these renames and continue, or go back and edit the names manually? ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "I'll edit manually",
                  color: "grey-7",
                  "no-caps": "",
                  onClick: _ctx.onRejectDuplicateMarkerNames
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  label: "Rename Markers",
                  "no-caps": "",
                  onClick: _ctx.onAcceptDuplicateMarkerNames
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showCloseMarkerWarningDialog,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showCloseMarkerWarningDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"500px","max-width":"95vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "warning",
                  color: "warning",
                  size: "24px",
                  class: "q-mr-sm"
                }),
                _cache[92] || (_cache[92] = _createElementVNode("div", { class: "text-h6" }, "Markers too close together", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[93] || (_cache[93] = _createElementVNode("div", { class: "text-body2 q-mb-md" }, " Each marker needs a distinct position (at least 2 m apart). We suggest removing the later row of each close pair: ", -1)),
                _createVNode(_component_q_list, {
                  bordered: "",
                  separator: "",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closeMarkerPairs, (pair) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: `${pair.earlierRow}-${pair.laterRow}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Row " + _toDisplayString(pair.laterRow) + " \"" + _toDisplayString(pair.laterName) + "\" - " + _toDisplayString(pair.meters.toFixed(1)) + " m from row " + _toDisplayString(pair.earlierRow) + " \"" + _toDisplayString(pair.earlierName) + "\" ", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "I'll edit manually",
                  color: "grey-7",
                  "no-caps": "",
                  onClick: _ctx.onRejectCloseMarkerWarning
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  label: _ctx.closeMarkerWarningActionLabel,
                  "no-caps": "",
                  onClick: _ctx.onRemoveCloseMarkerRows
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showInstructions,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.showInstructions) = $event)),
      title: "Pipelines",
      icon: "description",
      message: "Create a pipeline by entering a name, diameter, and uploading a CSV file with your marker positions.",
      tip: "Download an example CSV to see the expected format.",
      "tip-action-label": "Download example CSV",
      "z-index": 7000,
      onTipAction: _ctx.onDownloadExampleCsv
    }, null, 8, ["modelValue", "onTipAction"])
  ], 64))
}